import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ComputedRef } from 'vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  interface Props {
    price: number | string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Price',
  props: {
    price: {}
  },
  setup(__props: any) {

  // Vue
  const { n } = useI18n()

  // Props
  const props = __props

  // Computed
  const formattedPrice: ComputedRef<string> = computed(() => {
    let dividedPrice = Number(props.price)

    // Divide only if it's a whole number
    if (Number.isInteger(dividedPrice)) {
      dividedPrice = dividedPrice / 100
    }

    return n(dividedPrice, 'currency') // Format as currency
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(formattedPrice.value), 1))
}
}

})